import { SaveButton } from "components/Buttons"
import { CheckboxField } from "components/RenderInput"
import React from "react"
import { Col, Row } from "reactstrap"
import { Field } from "redux-form"

const CodesFilterModal = ({ searchHandler, closeHandler }) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Field name="physical" component={CheckboxField} label="Physical" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name="digital" component={CheckboxField} label="Digital" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name="unused" component={CheckboxField} label="Unused" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name="used" component={CheckboxField} label="Used" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name="pending" component={CheckboxField} label="Pending" />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Search"
            onClick={() => {
              searchHandler()
              closeHandler()
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default CodesFilterModal
